import * as ScreenOrientation from "expo-screen-orientation";
import { Platform } from "react-native";

function lockNativeOrientation(
  orientationLock: ScreenOrientation.OrientationLock,
  mode: "portrait" | "landscape"
) {
  if (Platform.OS === "web") return Promise.resolve();

  return ScreenOrientation.lockAsync(orientationLock).catch((error: unknown) => {
    console.log(`[orientation] ${mode} lock failed: ${String(error)}`);
  });
}

/** Ordinary app routes are phone-first and never rotate with the device. */
export function lockAppPortrait() {
  return lockNativeOrientation(
    ScreenOrientation.OrientationLock.PORTRAIT_UP,
    "portrait"
  );
}

/** The app-owned fullscreen player may use either landscape direction. */
export function lockPlayerLandscape() {
  return lockNativeOrientation(
    ScreenOrientation.OrientationLock.LANDSCAPE,
    "landscape"
  );
}
